var $ = require('js/sw-jquery/sw-jquery');

module.exports = function($fragment) {

  $fragment.swFindWithSelf('[data-sw-model-material-drag-and-drop-upload]').each(function() {

    var $el = $(this);
    require(['rrViewComponents/Model/MaterialConfigurator/ModelMaterialDragAndDropUploadComponent/ModelMaterialDragAndDropUpload'], function(ModelMaterialDragAndDropUpload) {

      new ModelMaterialDragAndDropUpload({
        el: $el
      });
    });

  });
};
